import { render, staticRenderFns } from "./RegisterClients.vue?vue&type=template&id=5384b785&scoped=true"
import script from "./RegisterClients.vue?vue&type=script&lang=js"
export * from "./RegisterClients.vue?vue&type=script&lang=js"
import style0 from "./RegisterClients.vue?vue&type=style&index=0&id=5384b785&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384b785",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5384b785')) {
      api.createRecord('5384b785', component.options)
    } else {
      api.reload('5384b785', component.options)
    }
    module.hot.accept("./RegisterClients.vue?vue&type=template&id=5384b785&scoped=true", function () {
      api.rerender('5384b785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/RegisterClients.vue"
export default component.exports